import { render, staticRenderFns } from "./TasinirHacizTalimatiTalepEvrakForm.vue?vue&type=template&id=59998fd9"
import script from "./TasinirHacizTalimatiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./TasinirHacizTalimatiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports